import { Injectable } from '@angular/core';
import {
  downloadInfoPageSectionHeaders,
  AttachmentDownloadRequestType,
  downloadInfoPageSectionKeys,
  AccordionTabs,
  pageUrl,
} from '../utility/constants';
import { BehaviorSubject } from 'rxjs';
import { ShipmentLabelGenerationModel } from 'src/app/features/model/hawb.model';
import { formatDate } from '@angular/common';
import { postPrintDataWhenReady } from '../utility/print-layout.util';

@Injectable({
  providedIn: 'root',
})
export class PrintService {
  public printTableData = new BehaviorSubject<any>({});
  public isSetDataForPreviewTable = new BehaviorSubject<any>({});
  private childWindowRef: Window | null = null;

  public setPrintTableData(data: any) {
    this.printTableData.next(data);
  }

  public setDataForPreviewTable(data: any) {
    this.isSetDataForPreviewTable.next(data);
  }

  public getHeaderSectionKeys(sectionName: string) {
    const sectionKeyMap = {
      [downloadInfoPageSectionKeys.mawbInfo]:
        AttachmentDownloadRequestType.mawbInfo,
      [downloadInfoPageSectionKeys.mawbmiscellaneous]:
        downloadInfoPageSectionHeaders.mawbmiscellaneous,
      [downloadInfoPageSectionKeys.details]: AccordionTabs.Details,
      [downloadInfoPageSectionKeys.events]: AccordionTabs.Events,
      [downloadInfoPageSectionKeys.attachments]: AccordionTabs.Attachments,
      [downloadInfoPageSectionKeys.notes]: AccordionTabs.Notes,
      [downloadInfoPageSectionKeys.mawbManifests]:
        downloadInfoPageSectionHeaders.mawbManifests,
      [downloadInfoPageSectionKeys.mawbFlights]:
        downloadInfoPageSectionHeaders.mawbFlights,
      [downloadInfoPageSectionKeys.manifestInfo]:
        downloadInfoPageSectionHeaders.manifestInfo,
      [downloadInfoPageSectionKeys.manifestsBag]:
        downloadInfoPageSectionHeaders.manifestBag,
      [downloadInfoPageSectionKeys.widgets]:
        downloadInfoPageSectionHeaders.widgets,
      [downloadInfoPageSectionKeys.blockUnblock]:
        downloadInfoPageSectionHeaders.blockUnblock,
      [downloadInfoPageSectionKeys.hawbInfo]:
        downloadInfoPageSectionHeaders.hawbInfo,
      [downloadInfoPageSectionKeys.hawbCommodity]:
        downloadInfoPageSectionHeaders.hawbCommodity,
      [downloadInfoPageSectionKeys.hawbRoles]:
        downloadInfoPageSectionHeaders.hawbRoles,
      [downloadInfoPageSectionKeys.hawbMiscellaneous]:
        downloadInfoPageSectionHeaders.hawbMiscellaneous,
      [downloadInfoPageSectionKeys.hawbStatusCode]:
        downloadInfoPageSectionHeaders.hawbStatusCode,
      [downloadInfoPageSectionKeys.hawbConsignee]:
        downloadInfoPageSectionHeaders.hawbConsignee,
      [downloadInfoPageSectionKeys.hawbShipper]:
        downloadInfoPageSectionHeaders.hawbShipper,
      [downloadInfoPageSectionKeys.bagInfo]:
        downloadInfoPageSectionHeaders.bagInfo,
      [downloadInfoPageSectionKeys.bagMiscellaneous]:
        downloadInfoPageSectionHeaders.bagMiscellaneous,
      [downloadInfoPageSectionKeys.bagPieces]:
        downloadInfoPageSectionHeaders.bagPieces,
      [downloadInfoPageSectionKeys.bagCriteria]:
        downloadInfoPageSectionHeaders.bagCriteria,
      [downloadInfoPageSectionKeys.userInfo]:
        downloadInfoPageSectionHeaders.userInfo,
      [downloadInfoPageSectionKeys.userDepartments]:
        downloadInfoPageSectionHeaders.userDepartments,
      [downloadInfoPageSectionKeys.loginInfo]:
        downloadInfoPageSectionHeaders.loginInfo,
      [downloadInfoPageSectionKeys.shipmentInfoFieldLevelAddFlow]:
        downloadInfoPageSectionHeaders.shipmentInfoFieldLevelAddFlow,
      [downloadInfoPageSectionKeys.agentInfo]:
        downloadInfoPageSectionHeaders.agentInfo,
      [downloadInfoPageSectionKeys.agentAddress]:
        downloadInfoPageSectionHeaders.agentAddress,
      [downloadInfoPageSectionKeys.hsCode]:
        downloadInfoPageSectionHeaders.hsCodeInfo,
      [downloadInfoPageSectionKeys.airlineInfo]:
        downloadInfoPageSectionHeaders.airlineInfo,
      [downloadInfoPageSectionKeys.airlineAddress]:
        downloadInfoPageSectionHeaders.airlineAddress,
      [downloadInfoPageSectionKeys.airportInfo]:
        downloadInfoPageSectionHeaders.airportInfo,
      [downloadInfoPageSectionKeys.airportAddress]:
        downloadInfoPageSectionHeaders.airportAddress,
      [downloadInfoPageSectionKeys.numberRange]:
        downloadInfoPageSectionHeaders.numberRange,
      [downloadInfoPageSectionKeys.numberRangeDetails]:
        downloadInfoPageSectionHeaders.numberRangeDetails,
      [downloadInfoPageSectionKeys.numberRanges]:
        downloadInfoPageSectionHeaders.numberRanges,
      [downloadInfoPageSectionKeys.accountAddress]:
      downloadInfoPageSectionHeaders.accountAddress,
        [downloadInfoPageSectionKeys.billingAddress]:
      downloadInfoPageSectionHeaders.billingAddress,
        [downloadInfoPageSectionKeys.customerManagement]:
      downloadInfoPageSectionHeaders.customerManagement,
       [downloadInfoPageSectionKeys.users]:
      downloadInfoPageSectionHeaders.users,
       [downloadInfoPageSectionKeys.details]:
      downloadInfoPageSectionHeaders.details,
       [downloadInfoPageSectionKeys.businessInformation]:
      downloadInfoPageSectionHeaders.businessInformation,
       [downloadInfoPageSectionKeys.accountInfo]:
      downloadInfoPageSectionHeaders.accountInfo,
       [downloadInfoPageSectionKeys.apChargeCodeInfo]:
      downloadInfoPageSectionHeaders.apChargeCodeInfo,
      [downloadInfoPageSectionKeys.apChargeCode]:
      downloadInfoPageSectionHeaders.apChargeCode,
      [downloadInfoPageSectionKeys.deliveryZoneInfo]:
      downloadInfoPageSectionHeaders.deliveryZoneInfo,
      [downloadInfoPageSectionKeys.deliveryZoneInfoTable]:
      downloadInfoPageSectionHeaders.deliveryZoneInfoTable,
      [downloadInfoPageSectionKeys.rateScaleInfo]:
      downloadInfoPageSectionHeaders.rateScaleInfo,
      [downloadInfoPageSectionKeys.rateScaleAccessorialCharges]:
      downloadInfoPageSectionHeaders.rateScaleAccessorialCharges,
      [downloadInfoPageSectionKeys.rateScaleWeightBasedCharges]:
      downloadInfoPageSectionHeaders.rateScaleWeightBasedCharges,
      [downloadInfoPageSectionKeys.apInvoiceInfo]:
      downloadInfoPageSectionHeaders.apInvoiceInfo,
      [downloadInfoPageSectionKeys.apCharges]:
        downloadInfoPageSectionHeaders.apCharges,
      [downloadInfoPageSectionKeys.arInvoiceInfo]:
        downloadInfoPageSectionHeaders.arInvoiceInfo,
      [downloadInfoPageSectionKeys.arCharges]:
        downloadInfoPageSectionHeaders.arCharges,
      [downloadInfoPageSectionKeys.bagInformation]:
        downloadInfoPageSectionHeaders.bagInfo,
      [downloadInfoPageSectionKeys.shipmentInfo]:
        downloadInfoPageSectionHeaders.hawbInfo,
      [downloadInfoPageSectionKeys.commodityDetails]:
        downloadInfoPageSectionHeaders.commodityDetails,
      [downloadInfoPageSectionKeys.linkedShipmentInfo]:
        downloadInfoPageSectionHeaders.linkedShipmentInfo,
      [downloadInfoPageSectionKeys.routingInfo]:
        downloadInfoPageSectionHeaders.routingInfo,
      [downloadInfoPageSectionKeys.routes]: downloadInfoPageSectionHeaders.routes,
      [downloadInfoPageSectionKeys.transitPoints]:
        downloadInfoPageSectionHeaders.transitPoints,
    };
    return sectionKeyMap[sectionName] || '';
  }

  public generateShipmentLabel(shipmentLabelInfo: any) {
    const labelData = this.prepLabelData(shipmentLabelInfo);
    this.childWindowRef = window.open(
      `${window.location.origin}${pageUrl.generateShipmentLabel}`,
      'Child Window',
      'top=0,left=0,height=50%,width=auto'
    );
    if (this.childWindowRef) {
      postPrintDataWhenReady(this.childWindowRef, labelData);
    }
  }

  private handleShipperInfo(
    data: any,
    shipperAccountNumber?: string,
    shipperRefNumber?: string
  ) {
    return Object.entries(data).length > 0
      ? {
          shipperName: data.name,
          companyName: data.companyName,
          account: shipperAccountNumber,
          referenceNumber: shipperRefNumber,
          addressLine1: data.address_1,
          addressLine2: data.address_2,
          city: data.city,
          state: data.stateName,
          postalCode: data.zipCode,
          countryCode: data.countryCode.slice(0, 2),
          phoneNumber: data.phone,
        }
      : {};
  }

  private handleConsigneeInfo(data: any) {
    return {
      consigneeName: data.name,
      companyName: data.companyName,
      addressLine1: data.address_1,
      addressLine2: data.address_2,
      city: data.city,
      state: data.stateName,
      postalCode: data.zipCode,
      country: data.country,
      countryCode: data.countryCode.slice(0, 2),
      phone: data.phone,
    };
  }

  private prepLabelData(data: any): ShipmentLabelGenerationModel {
    const result: ShipmentLabelGenerationModel = {
      shipmentExt: data.hawbExt,
      shipperInfo: this.handleShipperInfo(
        data.consigneeShipper.shipper,
        data.accountNumber,
        data.shipperReference
      ),
      consigneeInfo: this.handleConsigneeInfo(data.consigneeShipper.consignee),
      body: {
        dateAndTime: this.generateLabelDateAndTime(),
        value: `$${this.calculateTotalShipmentValue(data.commodityList)}`,
        weight: `${data.weight} lbs`,
        type:
          data.commodityList.length > 0
            ? this.identifyShipmentType(data.commodityList[0].commodity.value)
            : '',
        service: data.serviceType,
        dimensions: `${data.dimL} x ${data.dimW} x ${data.dimH} inches`,
        description:
          data.commodityList.length > 0
            ? data.commodityList[0].commodity.description
            : '',
        masterShipment: data.masterShipment,
      },
    };
    return result;
  }

  private generateLabelDateAndTime(): string {
    return `${formatDate(
      new Date(),
      'MM/dd/yyyy',
      'en-US'
    )}  -\n  ${new Date().getHours()}: ${new Date().getMinutes()}`;
  }

  private calculateTotalShipmentValue(commodityList: Array<object>): string {
    let totalValue = 0;
    commodityList.forEach((commodity: any) => {
      totalValue += +commodity.commodity.value;
    });
    const formattedNumber = totalValue.toFixed(2);
    return formattedNumber;
  }

  private identifyShipmentType(commodityValue: string): string {
    return +commodityValue > 0 ? 'APX' : 'DOC';
  }
}
